import BasicInfoSection from "./Sections/OnlineMerchantManagementBasicInfoSection";
import CheckoutConfigSection from "./Sections/OnlineMerchantManagementCheckoutConfigSection";
import OtherSection from "./Sections/OnlineMerchantManagementOtherSection";
import FinanceSection from "./Sections/OnlineMerchantManagementFinanceSection";
import BankSection from "./Sections/OnlineMerchantManagementBankSection";
import SettlementSection from "./Sections/OnlineMerchantManagementSettlementSection";
import UsdSettlementSection from "./Sections/OnlineMerchantManagementUsdSettlementSection";
import ProcessorEnableSection from "./Sections/OnlineMerchantManagementProcessorEnableSection";
import MdrSection from "./Sections/OnlineMerchantManagementMdrSection";
import PaymentConfigSection from "./Sections/OnlineMerchantManagementPaymentConfigSection";
import EmployeeSection from "./Sections/OnlineMerchantManagementEmployeeSection";

import InfoSection from "./Sections/OnlineEmployeeFormInfoSection";

import { OnlineMerchantCountryOrRegionOptions as CountryOrRegion } from "./Options/CountryOrRegion";
import { OnlineMerchantCityOptions as City } from "./Options/City";
import { OnlineAccountStatusOptions as accountStatus } from "./Options/AccountStatus";
import { OnlineEmployeePermissionsOptions as employeePermissions } from "./Options/EmployeePermisisons";

import TransactionAmountLimit from "./Components/TransactionAmountLimit";
import MdrTable from "./Components/OnlineMerchantManagementMdrTable";
import AccountStatusAlert from "./Components/AccountStatusAlert";

import StatusDialog from "./Dialog/OnlineMerchantManagementAccountStatusDialog";
import EmployeeChangePasswordDialog from "./Dialog/OnlineMerchantManagementEmployeeChangePasswordDialog";

import { createOnlineMerchantEntityApi, createOnlineMerchantMdrApi, getOnlineMerchantDropdownOptionsApi, getOnlineMerchantEntityApi, getOnlineMerchantMdrApi, getOnlineMerchantProcessorConfigApi, getOnlineAccountSuspensionRemarksApi, updateOnlineMerchantEntityApi, updateOnlineMerchantMdrApi, updateOnlineMerchantProcessorConfigApi, updateOnlineMerchantSettleCurrencyApi, updateOnlineMerchantSettleCurrencyInfoApi, getOnlineEmployeeListApi, updateOnlineEmployeePasswordApi, createOnlineEmployeeApi, updateOnlineEmployeeDetailApi, getOnlineEmployeeDetailApi } from "./Api/OnlineMerchantManagementApi";
import { buildCreateOnlineMerchantEntityPayload, buildCreateOnlineMerchantMdrPayload, buildUpdateOnlineMerchantEntityPayload, buildUpdateOnlineMerchantNuveiConfigPayload, buildUpdateOnlineMerchantSettleCurrencyInfoPayload, buildUpdateOnlineMerchantSettleCurrencyPayload, buildUpdateOnlineMerchantMdrPayload, buildUpdateOnlineMerchantStatusPayload, buildUpdateOnlineEmployeePasswordApiPayload, buildCreateOnlineEmployeeApiPayload, buildUpdateOnlineEmployeeStatusApiPayload, buildUpdateOnlineEmployeeDetailApiPayload } from "./Api/OnlineMerchantManagementPayloadBuilder";
import { parseEmployeeDetailPayload, parseMerchantEntityPayload, parseMerchantMdrPayload, parseMerchantNuveiConfigPayload } from "./Api/OnlineMerchantManagementPayloadParser";

export const OnlineMerchantManagement = {
  MerchantForm: {
    BasicInfoSection,
    CheckoutConfigSection,
    OtherSection,
    BankSection,
    FinanceSection,
    SettlementSection,
    UsdSettlementSection,
    ProcessorEnableSection,
    MdrSection,
    PaymentConfigSection,

    EmployeeSection,
  },
  EmployeeForm: {
    InfoSection
  },
  Options: {
    CountryOrRegion,
    City,
    accountStatus,
    employeePermissions
  },
  Components: {
    TransactionAmountLimit,
    MdrTable,
    AccountStatusAlert,

    StatusDialog,
    EmployeeChangePasswordDialog,
  },
  Api: {
    getDropdownOptions: getOnlineMerchantDropdownOptionsApi,
    createMerchantEntity: createOnlineMerchantEntityApi,
    createMerchantMdr: createOnlineMerchantMdrApi,
    updateMerchantProcessorConfig: updateOnlineMerchantProcessorConfigApi,
    getMerchantProcessorConfig: getOnlineMerchantProcessorConfigApi,
    getAccountSuspensionRemarks: getOnlineAccountSuspensionRemarksApi,
    getMerchantEntity: getOnlineMerchantEntityApi,
    getMerchantMdr: getOnlineMerchantMdrApi,
    updateMerchantEntity: updateOnlineMerchantEntityApi,
    updateMerchantSettleCurrency: updateOnlineMerchantSettleCurrencyApi,
    updateMerchantSettleCurrencyInfo: updateOnlineMerchantSettleCurrencyInfoApi,
    updateMerchantMdr: updateOnlineMerchantMdrApi,

    getEmployeeList: getOnlineEmployeeListApi,
    changeEmployeePassword: updateOnlineEmployeePasswordApi,
    createEmployee: createOnlineEmployeeApi,
    getEmployee: getOnlineEmployeeDetailApi,
    updateEmployee: updateOnlineEmployeeDetailApi,
  },
  PayloadBuilder: {
    createMerchantEntity: buildCreateOnlineMerchantEntityPayload,
    createMerchantMdr: buildCreateOnlineMerchantMdrPayload,
    updateNuveiConfig: buildUpdateOnlineMerchantNuveiConfigPayload,
    updateMerchantEntity: buildUpdateOnlineMerchantEntityPayload,
    updateMerchantSettleCurrency: buildUpdateOnlineMerchantSettleCurrencyPayload,
    updateMerchantSettleCurrencyInfo: buildUpdateOnlineMerchantSettleCurrencyInfoPayload,
    updateMerchantMdr: buildUpdateOnlineMerchantMdrPayload,
    updateMerchantStatus: buildUpdateOnlineMerchantStatusPayload,
    updateEmployeePassword: buildUpdateOnlineEmployeePasswordApiPayload,

    createEmployee: buildCreateOnlineEmployeeApiPayload,
    updateEmployeeDetail: buildUpdateOnlineEmployeeDetailApiPayload,
    updateEmployeeStatus: buildUpdateOnlineEmployeeStatusApiPayload,
  },
  PayloadParser: {
    merchantEntity: parseMerchantEntityPayload,
    merchantMdr: parseMerchantMdrPayload,
    merchantProcessorConfig: parseMerchantNuveiConfigPayload,

    employeeDetail: parseEmployeeDetailPayload
  }
}